import { cn } from '@/lib/utils';
import type { CMSImage } from '../schemas';

interface CMSImageProps {
  imageData: CMSImage;
  className?: string;
  style?: React.CSSProperties;
}
const CMSImage = ({ imageData, className, style }: CMSImageProps) => {
  const url = imageData.image?.url ?? '';
  const alt = imageData.image?.alt ?? '';

  return (
    <div
      style={style}
      className={cn('w-full', className)}
      data-component="CMSImage"
    >
      <img className="w-full" src={url} alt={alt} loading="lazy" />
    </div>
  );
};

export { CMSImage };
